import {
  GTS_FAILURE,
  GTS_PENDING,
  GTS_SUCCESS,
  DT_SUCCESS,
  UT_SUCCESS,
  UTC_SUCCESS,
  GNTS_SUCCESS,
  GNTS_PENDING,
} from './constants'

const initialState = {
  data: null,
  error: null,
  isLoading: false,
}

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case GTS_PENDING:
      return {
        ...state,
        isLoading: true,
        error: null,
        audits: [],
      }
    case GTS_SUCCESS:
      return {
        ...state,
        isLoading: false,
        error: null,
        ...action.payload,
      }
    case GNTS_PENDING:
      return {
        ...state,
        isLoading: false,
        error: null,
        audits: [
          ...state.audits,
          {id: 'loading', name: '', next_audit_period: null, last_audit_period: null},
        ],
      }
    case GNTS_SUCCESS:
      return {
        ...state,
        isLoading: false,
        error: null,
        audits: [...state.audits, ...action.payload.audits],
      }
    case DT_SUCCESS:
      const indexOfDeleteTemplate = state.audits.findIndex(a => {
        return a.id === action.payload
      })
      state.audits.splice(indexOfDeleteTemplate, 1)
      return {
        ...state,
      }
    case UT_SUCCESS:
      const indexOfUpdateTemplate = state.audits.findIndex(a => {
        return a.id === action.payload.id
      })
      state.audits[indexOfUpdateTemplate] = action.payload
      return {
        ...state,
      }
    case UTC_SUCCESS:
      const indexOfUpdatedCountTemplate = state.audits.findIndex(a => {
        return a.id === action.payload
      })
      state.audits[indexOfUpdatedCountTemplate].used_count =
        state.audits[indexOfUpdatedCountTemplate].used_count + 1
      return {
        ...state,
      }
    case GTS_FAILURE:
      return {
        ...state,
        error: action.payload,
        isLoading: false,
      }
    default:
      return state
  }
}

export default reducer
